var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "x-navigation-overlay",
    {
      attrs: { id: "navigation-overlay" },
      model: {
        value: _vm.menuOpen,
        callback: function ($$v) {
          _vm.menuOpen = $$v
        },
        expression: "menuOpen",
      },
    },
    [
      _c(
        "x-list",
        [
          _c(
            "x-list-tile",
            {
              on: {
                click: function ($event) {
                  return _vm.closeNavigation()
                },
              },
            },
            [
              _c("router-link", { attrs: { to: _vm.dashboardLink } }, [
                _vm._v("Dashboard"),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _vm.getAQuote
            ? _c(
                "x-list-tile",
                {
                  on: {
                    click: function ($event) {
                      return _vm.closeNavigation()
                    },
                  },
                },
                [
                  _c("router-link", { attrs: { to: "/agent/contract/new" } }, [
                    _vm._v("Get quotes"),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.$root.userCan("view facility")
            ? _c(
                "x-list-tile",
                {
                  on: {
                    click: function ($event) {
                      return _vm.closeNavigation()
                    },
                  },
                },
                [
                  _c(
                    "router-link",
                    { attrs: { to: "/agent/facility-manager" } },
                    [_vm._v("Facility manager")]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.$root.userCan("view securities")
            ? _c(
                "x-list-tile",
                {
                  on: {
                    click: function ($event) {
                      return _vm.closeNavigation()
                    },
                  },
                },
                [
                  _c(
                    "router-link",
                    { attrs: { to: _vm.dashboardSecuritiesLink } },
                    [_vm._v("Security manager")]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.$root.userCan("view contact management")
            ? _c(
                "x-list-tile",
                {
                  on: {
                    click: function ($event) {
                      return _vm.closeNavigation()
                    },
                  },
                },
                [
                  _c(
                    "router-link",
                    { attrs: { to: "/agent/contact-management" } },
                    [_vm._v("Contact management")]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "x-list-tile",
            {
              nativeOn: {
                click: function ($event) {
                  return _vm.logout()
                },
              },
            },
            [_c("a", [_vm._v("Logout")])]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }